// extracted by mini-css-extract-plugin
export var body = "_2b-8";
export var button = "_2b-0";
export var closeButton = "_2b-5";
export var content = "_2b-3";
export var empty = "_2b-f";
export var grid = "_2b-c";
export var header = "_2b-4";
export var icon = "_2b-1";
export var option = "_2b-d";
export var optionSelected = "_2b-e";
export var overlay = "_2b-2";
export var searchIcon = "_2b-a";
export var searchInput = "_2b-b";
export var searchWrapper = "_2b-9";
export var title = "_2b-6";
export var visuallyHidden = "_2b-7";